"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LarixAction = void 0;
const withdrawAction_1 = require("./action/withdrawAction");
const bn_js_1 = __importDefault(require("bn.js"));
const depositAction_1 = require("./action/depositAction");
const collateralAction_1 = require("./action/collateralAction");
const unCollateralAction_1 = require("./action/unCollateralAction");
const borrowAction_1 = require("./action/borrowAction");
const repayAction_1 = require("./action/repayAction");
class LarixAction {
    constructor(userInfo, signer) {
        this.userInfo = userInfo;
        this.signer = signer;
    }
    deposit(userMarketDetail, depositReserve, amount, obligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const supplyAction = new depositAction_1.DepositAction(this.signer, this.userInfo, userMarketDetail.market);
            const larixTransaction = yield supplyAction.deposit(new bn_js_1.default(amount), depositReserve, userMarketDetail.mining, obligation);
            this.transactionResults = larixTransaction.transactionResults;
            yield larixTransaction.send();
        });
    }
    withdraw(userMarketDetail, withReserve, amount, obligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const withdrawAction = new withdrawAction_1.WithdrawAction(this.signer, this.userInfo, userMarketDetail.market);
            const larixTransaction = yield withdrawAction.withdraw(new bn_js_1.default(amount), withReserve, userMarketDetail.mining, obligation);
            this.transactionResults = larixTransaction.transactionResults;
            yield larixTransaction.send();
        });
    }
    collateral(userMarketDetail, reserve, obligation) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userMarketDetail.mining == undefined) {
                throw new Error("Can not find mining");
            }
            const initObligationAction = new collateralAction_1.CollateralAction(this.signer, this.userInfo, userMarketDetail.market);
            const larixTransaction = yield initObligationAction.collateral(reserve, userMarketDetail.mining, obligation);
            this.transactionResults = larixTransaction.transactionResults;
            yield larixTransaction.send();
        });
    }
    unCollateral(userMarketDetail, reserve, obligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const exitObligationAction = new unCollateralAction_1.UnCollateralAction(this.signer, this.userInfo, userMarketDetail.market);
            if (userMarketDetail.mining == undefined) {
                throw new Error("Can not find mining account");
            }
            const larixTransaction = yield exitObligationAction.unCollateral(reserve, userMarketDetail.mining, obligation);
            this.transactionResults = larixTransaction.transactionResults;
            yield larixTransaction.send();
        });
    }
    borrow(userMarketDetail, borrowReserve, amount, obligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowAction = new borrowAction_1.BorrowAction(this.signer, this.userInfo, userMarketDetail.market);
            const larixTransaction = yield borrowAction.borrow(new bn_js_1.default(amount), borrowReserve, obligation);
            this.transactionResults = larixTransaction.transactionResults;
            yield larixTransaction.send();
        });
    }
    repay(userMarketDetail, reserve, amount, obligation) {
        return __awaiter(this, void 0, void 0, function* () {
            const repayAction = new repayAction_1.RepayAction(this.signer, this.userInfo, userMarketDetail.market);
            const larixTransaction = yield repayAction.repay(new bn_js_1.default(amount), reserve, obligation);
            this.transactionResults = larixTransaction.transactionResults;
            yield larixTransaction.send();
        });
    }
}
exports.LarixAction = LarixAction;
